// Inline action button for DataTable rows. Styled to fit in a tight
// `text-[12px]` row without breaking the layout.
//
// Use one button per primary action. For destructive/secondary actions,
// pair with `kind="ghost"` so the row doesn't shout.

import type { ReactNode } from 'react';

interface RowActionProps {
  onClick: () => void;
  disabled?: boolean;
  kind?: 'primary' | 'ghost' | 'danger';
  busy?: boolean;
  children: ReactNode;
}

export function RowAction({
  onClick,
  disabled,
  kind = 'ghost',
  busy,
  children,
}: RowActionProps) {
  const base =
    'inline-flex items-center rounded-md px-2 py-1 text-[11.5px] font-medium transition disabled:cursor-not-allowed disabled:opacity-50';
  const variant =
    kind === 'primary'
      ? 'bg-[color:var(--bo-ink)] text-white hover:bg-black'
      : kind === 'danger'
        ? 'border border-[#fecaca] bg-[#fff1f2] text-[#9f1239] hover:bg-[#ffe4e6]'
        : 'border border-[color:var(--bo-line)] bg-white text-[color:var(--bo-ink)] hover:border-[color:var(--bo-mute)]';
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled && !busy) onClick();
      }}
      disabled={disabled || busy}
      className={`${base} ${variant}`}
    >
      {busy ? '…' : children}
    </button>
  );
}
